import React from "react";

import Button from "devextreme-react/button";
import TextBox from "devextreme-react/text-box";
import Balancer from "react-wrap-balancer";

// import { useDispatch } from "react-redux";
import { useAppFusion, useReverseRoute } from "../../contexts";
import "./notAuth.scss";

// import "../../style/dx.generic.teamZebra.min.css";

const NotFusionAuth = () => {
  const { routeInit } = useReverseRoute("NotFusionAuth");
  const { drytest, isAuthenticated, login, logout, register } = useAppFusion();

  return (
    <div id="jgap-main" className="not-authenticated">
      <div ref={routeInit}></div>
      <div className="appbody">
        <h1>
          <Balancer>Jurnal Gold Admin Panel</Balancer>
        </h1>
        <h4>Acces la demo, Gestionare de licente si resurse, samd</h4>
        <div className="button-wrapper">
          <Button
            // className={}
            width={184}
            height={64}
            stylingMode={"text"}
            text={"Test state"}
            icon={"help"}
            onClick={() => {
              drytest();
            }}
            visible={false}
          />
          <Button
            width={184}
            height={64}
            stylingMode={"contained"}
            text={"Inregistrare"}
            icon={"unlock"}
            onClick={() => {
              register();
            }}
            visible={true}
          />
          <Button
            width={184}
            height={64}
            stylingMode={"outlined"}
            text={"Autentificare"}
            icon={"user"}
            onClick={() => {
              login();
            }}
          />
        </div>
        {/* <p>Crearea contului de utilizator este gratuita si nu implica nici un fel de obligatie din partea dumneavoastra.</p> */}
        <h5>
          <Balancer>
            Această pagină se află încă în dezvoltare. Veti avea acces la
            resurse, pe masura ce avansam cu lucrarile
          </Balancer>
        </h5>
        <h5> Va multumim pentru intelegere</h5>
        <div className="footer-links">
          <a href="https://www.softwiz.ro" target={"_blank"} rel="noreferrer">
            {"Softwiz.ro - compania"}
          </a>
          {" | "}
          <a href="https://help.jurnalgold.ro" target={"help"} rel="">
            {"JurnalGold.ro - help"}
          </a>
          {" | "}
          <a href="mailto:support.jurnalgold.ro">{"Email - suport"}</a>
        </div>
      </div>
    </div>
  );
};

export default NotFusionAuth;
